<template>

  <div class="container">
    <div class="search-wrap">
      <van-search
          v-model="searchContent"
          shape="round"
          @search="onSearchContent"
          :left-icon="require('@/assets/icons/v2/icon_write_data_search.svg')"
          placeholder="Search History"
      />
      <SearchFilter :filter-condition="filterCondition" @onItemSelectedChange="onItemSelectedChange" @onApply="onApply"/>
    </div>

    <div class="content">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          pulling-text="Pull down to refresh"
          loading-text="Loading..."
          success-text="Refresh success"
          loosing-text="Release to refresh"
      >
        <van-list
            v-if="!isEmpty"
            v-model="loading"
            :finished="finished"
            finished-text="No more data"
            loading-text="Loading more..."
            :error.sync="error"
            error-text="Load fail! Click reload"
            @load="onLoad"
        >
          <div v-for="(item,index) in recordList" :key="index">
            <WriteDataItem
                :flavor-info="item"
                :scan-info="item.scanInfo"/>
          </div>
        </van-list>
        <div class="no-data" v-else @click="onLoad">
          <div class="no-data">
            <img src="@/assets/icons/brand/icon_no_brand_data.png" style="width:150px;height:150px;"/>
            <span style="margin-top:20px;margin-bottom:60px;color: #999999">No data</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <CustomizationBottomOperate text="Finish" @onNext="onFinished"/>

  </div>
</template>

<script>
import BrandRecordItem from "@/components/BrandRecordItem.vue";
import HistoryCurve from "@/views/HistoryCurve.vue";
import produce from "@/api/produce";
import log from "@/util/log";
import WriteDataItem from "@/components/WriteDataItem.vue";
import bus from "@/util/EventBus";
import SearchFilter from "@/components/SearchFilter.vue";
import CustomizationBottomOperate from "@/components/customization/CustomizationBottomOperate.vue";

export default {
  name: "History",
  components: { CustomizationBottomOperate, SearchFilter, WriteDataItem, HistoryCurve, BrandRecordItem },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      isFirst: true,
      recordList: [],
      isEmpty: false,

      searchContent: "",
      filterCondition: []
    };
  },
  methods: {
    onFinished() {
      this.$router.replace('/Enterprise')
    },
    async loadData() {
      const filterParams = await produce.selectBrandAndProduct();
      const scanTimes = await produce.selectBrandScanTime();

      const brandOptions = filterParams.omniBrandList.map(item => {
        return {
          text: item.brandName,
          value: item.id
        };
      });
      // brandOptions.unshift({text: '',value:''})


      const dateParams = [];

      const productOptions = filterParams.omniIkrusherProductList.map(item => {
        return {
          text: item.deviceName,
          value: item.id
        };
      });
      // productOptions.unshift({text: '',value:''})

      const flavorOptions = filterParams.omniFlavorList.map(item => {
        return {
          text: item.flavorName,
          value: item.id
        };
      });
      // flavorOptions.unshift({text: '',value:''})

      this.filterCondition = [
        {
          id: 0,
          value: "",
          placeHolder: "Brand",
          options: brandOptions
        },{
          id: 0,
          value: "",
          placeHolder: "Date",
          options: scanTimes
        },  {
          id: 0,
          value: "",
          placeHolder: "Product",
          options: productOptions
        },{
          id: 0,
          value: "",
          placeHolder: "Flavor",
          options: flavorOptions
        }
      ];

    },
    onItemSelectedChange(index, selectedIndex, val) {
      this.filterCondition[index].value = selectedIndex;
      this.filterCondition[index].id = val.value;
      this.onSearchContent()
    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onSearchContent() {
      this.pageNum = 1;
      this.isFirst = true
      this.onLoad();
    },
    onApply(selectedTime) {

      this.pageNum = 1;
      this.isFirst = true
      if (selectedTime === "") {
        this.filterCondition[1].value = ``;
      }else {
        this.filterCondition[1].value = `${selectedTime.year}-${selectedTime.month}-${selectedTime.day}`;
      }

      this.onLoad();
    },
    async onLoad() {
      if (this.refreshing) {
        this.pageNum = 1;
        this.historyList = [];
      }
      try {
        const resp = await produce.scanBrandRecordList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          historyContent: this.searchContent,
          brandId: (this.filterCondition && this.filterCondition.length > 0 && this.filterCondition[0].id) || "",
          time: (this.filterCondition && this.filterCondition.length > 0 && this.filterCondition[1].value) || "",
          productId: (this.filterCondition && this.filterCondition.length > 0 && this.filterCondition[2].id) || "",
          flavorId: (this.filterCondition && this.filterCondition.length > 0 && this.filterCondition[3].id) || "",

        }, this.isFirst);
        const { data, code, message, total } = resp;
        if (code !== 200) {
          throw message;
          return;
        }
        data.forEach(item => {
          if (item.scanType === 1) { //包装盒
            item.scanInfo = [
              { label: "Boxes quantity", value: item.boxQuantity },
              { label: "Quantity", value: item.quantity },
              { label: "Device model", value: item.deviceTypeName }
            ];
          } else if (item.scanType === 2) { //单台设备
            item.scanInfo = [
              { label: "Quantity", value: item.quantity },
              { label: "Device model", value: item.deviceTypeName }
            ];
          }
          item.labelList = item.labelName.split(",");
        });
        if (this.pageNum === 1) {
          this.recordList = data;
        }else {
          this.recordList = this.recordList.concat(data);
        }

        this.isEmpty = (total === 0);
        if (total != 0) {
          this.isFirst = false;
        }
        //刷新结束
        if (this.refreshing) {
          this.refreshing = false;
        } else {
          this.loading = false;
        }
        if (this.recordList.length >= total) {
          this.finished = true;
        }
        this.pageNum += 1;

      } catch (e) {
        log(e);
        if (e instanceof String) {
          this.$toast({ message });
        } else if (e instanceof Error) {
          this.$toast({ message: e.message });
        }

        this.loading = false;
        this.error = true;
      }

    }
  },
  async mounted() {

    setTimeout(() => {
      bus.$emit("stepChange", 3);
    }, 100);

    await this.loadData();
  }
};
</script>


<style scoped lang="less">
.content {
  height: 100%;
  overflow-y: auto;
  background: #f6f6f6;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
}


.no-data {
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: white;
  color: #939598;
}

.search-wrap {
  border-radius: 12px;
  background: white;
}

.van-search {
  background: transparent;
}


::v-deep .van-field {
  align-items: center;

  .van-field__left-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .van-icon__image {
    width: 20px;
    height: 21px;
  }

  .van-search__content {
    background: #F2F3F5;
  }

  .van-field__body {
    font-size: 14px;
  }
}

.van-list {
  & > * {
    margin-top: 12px;
  }
}

::v-deep .van-pull-refresh {
  overflow: unset;
}


</style>
